import React from 'react';
import {format} from 'date-fns'
import PropTypes from 'prop-types';

const TransactionDateFormatRenderer = (props) => {
  const date = props.value ? format(new Date(props.value), "dd-MMM-yyyy h:mm aa") : null;
  
  return (
    <>{date}</>
  );
};

TransactionDateFormatRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)])
};

export default TransactionDateFormatRenderer;
